import { useMemo, useState } from "react";
import { useWebsite } from "../../../Context/WebSiteContext";
import { api } from "../../../../../../../utils/api";
import { useLocation } from "react-router-dom";
import "./FormClassic.css";

const FormClassic = ({ config, formulario }) => {
  const { formData } = useWebsite();
  const [form, setForm] = useState({ name: "", email: "", phone: "", cep: "" });
  const mapaLoc =
    config.loc?.localizacao || "https://www.google.com/maps/embed?pb=!1m18...";
  const { state } = useLocation();
  // console.log("CONFIGGGGGGGGGG FORM", config);

  const mergedConfig = useMemo(
    () => ({
      ...config,
      ...formData,
    }),
    [config, formData]
  );

  const formConfig = {
    ...(mergedConfig?.formulario || formulario || {}),
  };

  formConfig.name = formConfig.name ?? false;
  formConfig.email = formConfig.email ?? false;
  formConfig.phone = formConfig.phone ?? false;
  formConfig.cep = formConfig.cep ?? false;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const enterprise_id = state?.enterprise_id;
    try {
      await api.post("/landingPage/lead", { ...form, enterprise_id });
      alert("Enviado!");
    } catch (err) {
      alert("Erro ao enviar!");
      console.error(err);
    }
  };

  return (
    <section
      id="formulario"
      className="d-flex flex-column flex-md-row w-100"
      style={{ minHeight: "100vh", overflow: "hidden" }}
    >
      {/* Iframe ocupando metade esquerda */}
      <div className="col-12 col-md-6 p-0 map-container">
        <iframe
          title="Localização"
          src={mapaLoc}
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Formulário na metade direita */}
      <div
        className="col-12 col-md-6 d-flex align-items-center justify-content-center"
        style={{
          backgroundColor: "#fff",
          color: "white",
          padding: "2rem",
        }}
      >
        <div
          className="p-5 shadow rounded w-100"
          style={{
            maxWidth: "500px",
            backgroundColor: `#${config.primaryColor || "0d1b2a"}`,
          }}
        >
          <h2
            className="mb-4 fs-3 text-center"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            FALE CONOSCO
          </h2>

          <form id="formulario" onSubmit={handleSubmit}>
            {config.formulario?.name && (
              <div className="mb-3">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Nome"
                  value={form.name}
                  onChange={handleChange}
                  style={{
                    borderRadius: "6px",
                    padding: "0.75rem",
                    fontSize: "1rem",
                  }}
                />
              </div>
            )}
            {config.formulario?.email && (
              <div className="mb-3">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                  value={form.email}
                  onChange={handleChange}
                  style={{
                    borderRadius: "6px",
                    padding: "0.75rem",
                    fontSize: "1rem",
                  }}
                />
              </div>
            )}
            {config.formulario?.phone && (
              <div className="mb-3">
                <input
                  type="tel"
                  name="phone"
                  className="form-control"
                  placeholder="Telefone"
                  value={form.phone}
                  onChange={handleChange}
                  style={{
                    borderRadius: "6px",
                    padding: "0.75rem",
                    fontSize: "1rem",
                  }}
                />
              </div>
            )}
            {config.formulario?.cep && (
              <div className="mb-4">
                <input
                  type="text"
                  name="cep"
                  className="form-control"
                  placeholder="CEP"
                  value={form.cep}
                  onChange={handleChange}
                  style={{
                    borderRadius: "6px",
                    padding: "0.75rem",
                    fontSize: "1rem",
                  }}
                />
              </div>
            )}

            <button
              type="submit"
              className="btn w-100 fw-bold"
              style={{
                backgroundColor: `#${config.secondaryColor || "1e5ba5"}`,
                color: `#${config.primaryColor || "ffffff"}`,
                padding: "0.75rem",
                fontSize: "1rem",
                borderRadius: "6px",
                border: `1px solid #${config.primaryColor || "ffffff"}`,
              }}
            >
              Enviar
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default FormClassic;
